import { Header } from '../../js/front/components/Header';
document.querySelectorAll( '.p-header' ).forEach( ( block ) => {

	new Header( block )

} );
